import {eventNames, orderCompleteEvent} from './constants';
import {OrderResponse} from './order-types';
import {checkoutGtmData} from './tagmanager';
import {orderDetailInfo} from './types';

export const coupanAppliedMoengage = (res: OrderResponse) => {
  let productPrices = '';
  let productNames = '';
  let productsId = '';
  let productsBrand = '';

  res.itemList?.map((itemData, index, array) => {
    if (index === array.length - 1) {
      productPrices += itemData.extSellPrice.toString();
    } else {
      productPrices += itemData.extSellPrice + ' , ';
    }
  });

  if (res.productList != null) {
    const obj = Object.entries(res.productList).map(([key, value]) => ({
      value,
    }));

    obj.map((itemData, index, array) => {
      if (index === array.length - 1) {
        productsBrand += itemData.value.itemBrand.toString();
        productsId += itemData.value.itemID.toString();
        productNames += itemData.value.itemDesc.toString();
      } else {
        productsBrand += itemData.value.itemBrand + ' , ';
        productsId += itemData.value.itemID + ' , ';
        productNames += itemData.value.itemDesc + ' , ';
      }
    });
  }

  const orderDetail: orderDetailInfo = {
    product_ID: productsId,
    product_Name: productNames,
    price: productPrices,
    brand: productsBrand,
    eventName: eventNames.couponAppliedPaymentEvent,
    event: orderCompleteEvent,
    orderID: res.orderId,
    // payment_Mode: 'js checkout'
    //order_Address_City:string;
    // first_Name: string;
    //last_Name:string;
    //category_Name:string;
    //category_Type:string;
    //purchaseDate: new Date().to;
  };
  checkoutGtmData(orderDetail);
};
export const proceedToCheckoutMoengageCall = (res: OrderResponse) => {
  let productPrices = '';
  let productNames = '';
  let productsId = '';
  let productsBrand = '';
  res.itemList?.map((itemData, index, array) => {
    if (index === array.length - 1) {
      productPrices += itemData.extSellPrice.toString();
    } else {
      productPrices += itemData.extSellPrice + ' , ';
    }
  });
  if (res.productList != null) {
    const obj = Object.entries(res.productList).map(([key, value]) => ({
      value,
    }));
    obj.map((itemData, index, array) => {
      if (index === array.length - 1) {
        productsBrand += itemData.value.itemBrand.toString();
        productsId += itemData.value.itemID.toString();
        productNames += itemData.value.itemDesc.toString();
      } else {
        productsBrand += itemData.value.itemBrand + ' , ';
        productsId += itemData.value.itemID + ' , ';
        productNames += itemData.value.itemDesc + ' , ';
      }
    });
  }
  console.log(productPrices);
  const orderDetail: orderDetailInfo = {
    product_ID: productsId,
    product_Name: productNames,
    price: productPrices,
    brand: productsBrand,
    eventName: eventNames.selfCheckout,
    event: orderCompleteEvent,
    orderID: res.orderId,
    // payment_Mode: 'js checkout'
    //order_Address_City:string;
    // first_Name: string;
    //last_Name:string;
    //category_Name:string;
    //category_Type:string;
    //purchaseDate: new Date().to;
  };
  checkoutGtmData(orderDetail);
};

export const paymentRecieveMoengageCall = (orderResp: OrderResponse | null) => {
  if (orderResp != null) {
    let productPrices = '';
    let productNames = '';
    let productsId = '';
    let productsBrand = '';

    orderResp.itemList?.map((itemData, index, array) => {
      if (index === array.length - 1) {
        productPrices += itemData.extSellPrice.toString();
      } else {
        productPrices += itemData.extSellPrice + ' , ';
      }
    });

    if (orderResp.productList != null) {
      const obj = Object.entries(orderResp.productList).map(([key, value]) => ({
        value,
      }));

      obj.map((itemData, index, array) => {
        if (index === array.length - 1) {
          productsBrand += itemData.value.itemBrand.toString();
          productsId += itemData.value.itemID.toString();
          productNames += itemData.value.itemDesc.toString();
        } else {
          productsBrand += itemData.value.itemBrand + ' , ';
          productsId += itemData.value.itemID + ' , ';
          productNames += itemData.value.itemDesc + ' , ';
        }
      });
    }

    console.log(productPrices);

    const orderDetail: orderDetailInfo = {
      product_ID: productsId,
      product_Name: productNames,
      price: productPrices,
      brand: productsBrand,
      eventName: eventNames.paymentRecieveEvent,
      event: orderCompleteEvent,
      orderID: orderResp.orderId,
      // payment_Mode: 'js checkout'
      //order_Address_City:string;
      // first_Name: string;
      //last_Name:string;
      //category_Name:string;
      //category_Type:string;
      //purchaseDate: new Date().to;
    };
    checkoutGtmData(orderDetail);
  }
};
export const onPayNowMoengageEvent = (orderResp: OrderResponse) => {
  let productPrices = '';
  let productNames = '';
  let productsId = '';
  let productsBrand = '';

  orderResp.itemList?.map((itemData, index, array) => {
    if (index === array.length - 1) {
      productPrices += itemData.extSellPrice.toString();
    } else {
      productPrices += itemData.extSellPrice + ' , ';
    }
  });

  if (orderResp.productList != null) {
    const obj = Object.entries(orderResp.productList).map(([key, value]) => ({
      value,
    }));

    obj.map((itemData, index, array) => {
      if (index === array.length - 1) {
        productsBrand += itemData.value.itemBrand.toString();
        productsId += itemData.value.itemID.toString();
        productNames += itemData.value.itemDesc.toString();
      } else {
        productsBrand += itemData.value.itemBrand + ' , ';
        productsId += itemData.value.itemID + ' , ';
        productNames += itemData.value.itemDesc + ' , ';
      }
    });
  }

  console.log(productPrices);

  const orderDetail: orderDetailInfo = {
    product_ID: productsId,
    product_Name: productNames,
    price: productPrices,
    brand: productsBrand,
    eventName: eventNames.onPaynowEvent,
    event: orderCompleteEvent,
    orderID: orderResp.orderId,
    // payment_Mode: 'js checkout'
    //order_Address_City:string;
    // first_Name: string;
    //last_Name:string;
    //category_Name:string;
    //category_Type:string;
    //purchaseDate: new Date().to;
  };
  checkoutGtmData(orderDetail);
};
